import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TrevorIcon } from '@trevor/ui-components';
import { SharedDataPresentationNavigation } from '@/features/dataPresentation/navigation/SharedDataPresentationNavigation';
import { formatTimestamp } from '@/util/helpers/time-helpers';
import {
  layerUserInteraction,
  loadHtmlView,
  modalInteraction,
} from '../actions';
import { SHARE_HTML } from '../util/enums/EnumModals';
import DataPresentationContainer from './DataPresentationContainer';
import PinComponent from '../components/PinComponent';
import flex from '../css/module/flex.css';
import css from '../css/module/shareHtml.css';

class ShareHtml extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartHeight: 500,
    };
    this.chartArea = React.createRef();
  }

  componentDidMount() {
    // set show charting options to true
    this.props.onActivateCharting();
  }

  componentDidUpdate(prevProps) {
    const { state, onLoadHtmlView, sharedView, loadingRows } = this.props;
    if (state.pin.length < 5) {
      // do nothing
    } else {
      onLoadHtmlView(sharedView, state.pin);
    }

    if (loadingRows && !prevProps.loadingRows) {
      const offset = this.chartArea.current.offsetTop;
      const viewPortHeight = window.innerHeight;
      this.setState({
        chartHeight: viewPortHeight - offset - 150,
      });
    }
  }

  render() {
    const { state, dataTable, loadingRows, userInteraction, hasErrorMsg } =
      this.props;

    if (loadingRows || dataTable || (hasErrorMsg && !state.wrongPin)) {
      return (
        <div style={{ height: '100vh', overflow: 'hidden' }}>
          <div className={css.navBar}>
            <a href="https://trevor.io/?ref=shareExternal" target="_blank">
              <TrevorIcon
                name="logo-symbol"
                height="30.32"
                width="24"
                style={{ marginRight: '12px' }}
              />
            </a>
            <span>Powered by Trevor.io</span>
          </div>
          <div className={css.titleContainer}>
            <h3>{state.title}</h3>
            <div style={{ marginBottom: '15px' }}>
              {!state.updatedAt ? null : (
                <span className="faint">
                  Results retrieved: {formatTimestamp(state.updatedAt)}.{' '}
                </span>
              )}
              {!state.rowCount ? null : state.rowCount ===
                dataTable.rows().length ? (
                <span className="faint">Displaying {state.rowCount} rows.</span>
              ) : (
                <span className="faint">
                  Limited to 5000 cells ({dataTable.rows().length} rows).
                </span>
              )}
            </div>
          </div>
          <div
            ref={this.chartArea}
            className={css.chartContainer}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <SharedDataPresentationNavigation />
            <DataPresentationContainer
              chartContainerHeight={this.state.chartHeight}
              isShareHTML
            />
          </div>
        </div>
      );
    }

    if (hasErrorMsg) {
      return (
        <h4 style={{ marginTop: '30px', textAlign: 'center' }}>WRONG PIN</h4>
      );
    }

    const loadData = (pin) => {
      userInteraction({ pin })();
    };

    return (
      <div
        style={{ height: '100vh', marginTop: '-10px' }}
        className={flex.middle}
      >
        <PinComponent onPinReady={(pin) => loadData(pin)} hideLogo />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dataTable: state.rows.dataTable,
    loadingRows: state.rows.loading,
    state: state.shareHtml,
    hasErrorMsg: !!state.rows.errorMsg,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onActivateCharting: () => {
      dispatch(
        layerUserInteraction({ event: 'toggle-charting', newValue: true }),
      );
    },
    userInteraction: (props) => (e) => {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      dispatch(modalInteraction(SHARE_HTML, props));
    },
    onLoadHtmlView: (viewSeries, pin) => {
      dispatch(loadHtmlView(viewSeries, pin));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareHtml);
